import { useLot } from 'api'
import { i18n, superFetch } from 'commons'
import { addNotification } from 'notification'
import { FC, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import { useSelector } from 'react-redux'
import { Button, Input, Spinner } from 'reactstrap'
import { getLotId } from 'store/selection'

export const ProgramDeleteDialog: FC<{ onClose: () => void, onDeleted: () => void }> = ({
  onClose,
  onDeleted
}) => {
  const { t } = useTranslation()
  const lotId = useSelector(getLotId)
  const lot = useLot(lotId as number)
  if (!lot) return null
  const lotName = lot.Nom

  const [input, setInput] = useState<string>('')

  const match = input === t('lot.program.deleteConfirmWord')

  const [mutateDelete, deleteResult] = useMutation(
    () => {
      return superFetch({
        url: `program/${lotId}`,
        method: 'DELETE',
      })
    },
    {
      useErrorBoundary: false,
      throwOnError: true,
      onSuccess: () => {
        addNotification({
          type: 'success',
          message: t('lot.program.programDeleteSuccess'),
        })
        onDeleted()
        onClose()
      },
      onError: (error: any) => {
        const status = error.response.status
        let errorMessage = t('lot.program.genericDeleteError')
        console.log(status)
        if(status == 404){
          errorMessage = t('lot.program.noProgramToDeleteError')
        } else {
          errorMessage = error.message
        }
        addNotification({
          type: 'danger',
          title: t('lot.program.errorTitle'),
          message: errorMessage,
        })
      },
    },
  )

  return (
    <div css={{ '>*:not(:last-child)': { marginBottom: '1.5rem' } }}>
      <p>
        {t('contract.delete.p1')}
        <br />
        {t('contract.delete.p2')}
        <br />
        {t('lot.program.programDeleteWarning', { name: lotName })}
        <br />
        {t('lot.program.programDeleteConfirm')}
      </p>

      <Input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        disabled={deleteResult.status == 'loading'}
      />

      <Button
        color={match ? 'danger' : 'light'}
        disabled={!match || deleteResult.status == 'loading'}
        onClick={() => mutateDelete()}
      >
        {deleteResult.status == 'loading' ? (
          <>
            <Spinner size="sm" style={{ marginRight: '.6rem' }} />
            <span>{t('lot.delete.deleting')}</span>
          </>
        ) : (
          <span>{t('lot.program.programDeleteSumbit')}</span>
        )}
      </Button>
    </div>
  )
}
